import { Intercom, shutdown } from '@intercom/messenger-js-sdk'
import { QuestionMarkIcon } from '@radix-ui/react-icons'
import cx from 'clsx'
import React, { useEffect } from 'react'

import { IntercomChatIcon } from './IntercomChatIcon'

export function getIntercomLauncherOffset (placement: 'inline' | 'top'): {
  right: number;
  bottom: number;
  left?: number;
  height?: number;
} {
  const launcher = document.getElementById('intercom-launcher')
  const rect = launcher?.getBoundingClientRect()
  if (!rect) {
    return {
      right: 0,
      bottom: 0,
      left: 0,
    }
  }

  const spacingRight = window.innerWidth - (rect.x + rect.width)
  const spacingBottom = window.innerHeight - (rect.y + rect.height)

  if (placement === 'inline') {
    return {
      right: rect.width + 2 * spacingRight,
      bottom: spacingBottom,
      height: rect.height,
    }
  }

  return {
    bottom: rect.height + spacingBottom + spacingRight,
    right: spacingRight,
    left: spacingRight,
  }
}

const intercomLauncherId = 'intercom-launcher'
export const useHideIntercomLauncher = () => {
  useEffect(() => {
    const launcher = document.getElementById(intercomLauncherId)
    if (launcher) {
      launcher.dataset.hidden = 'true'
      return () => {
        launcher.dataset.hidden = 'false'
      }
    }
  }, [])
}

const IntercomLauncher: React.FC<{
  className?: string;
  appId: string;
  contextJwt: string;
}> = ({ className, appId, contextJwt }) => {
  useEffect(() => {
    Intercom({
      app_id: appId,
      custom_launcher_selector: `#${intercomLauncherId}`,
      hide_default_launcher: true,
      intercom_user_jwt: contextJwt,
    })
    return () => shutdown()
  }, [])

  const intercomLauncherClassName = cx('data-[hidden=true]:hidden', 'fixed', 'm-4', 'bottom-0', 'right-0', 'bg-white', 'border-gray-200', 'rounded-full', 'p-2', 'border', 'shadow-md', className)

  return (
    <button
      id={intercomLauncherId}
      className={intercomLauncherClassName}
      aria-label='Open Intercom'
    >
      <div className='relative'>
        <IntercomChatIcon />
        <QuestionMarkIcon aria-hidden className='absolute text-white' style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
      </div>
    </button>
  )
}

export default IntercomLauncher
